import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

const faleConosco = $("#faleConoscoForm");
if (document.getElementById("file")) {
    document.getElementById("file").addEventListener("change", function () {
        const fileName =
            this.files.length > 0
                ? this.files[0].name
                : "Nenhum arquivo selecionado";
        document.getElementById("file-name").textContent = fileName;
    });
}

if (faleConosco.length > 0) {
    $("#phone").mask("(00) 0 0000-0000");
    $("#cep").mask("00000-000");
    $("#cpf").mask("000.000.000-00");

    $(".claim-form").hide();

    $("body").on("click", "#modal-button", function () {
        $(".modal-policy").addClass("modal-policy-active");
    });

    $("body").on("click", ".button-close", function () {
        $(".modal-policy").removeClass("modal-policy-active");
    });

    $("body").on("click", ".backshadow", function () {
        $(".modal-policy").removeClass("modal-policy-active");
    });

    $("body").on("change", ".assunto", function () {
        if ($(".type-form").val() == "0060") {
            $(".claim-form").show();
            $(".claim-required").attr("required", true);
            $("#cidade option:selected").val("");
            $("#estado option:selected").val("");
            $("#pais option:selected").val("BR");

            $("#numero").on("input", function () {
                var inputVal = $(this).val();
                if (inputVal.length > 10) {
                    $(this).val(inputVal.substring(0, 10));
                }
            });
        } else {
            $(".claim-form").hide();
            $(".claim-required").attr("required", false);
            $(".ipt-celular").attr("required", true);
            $("#cidade option:selected").val("");
        }
    });

    async function montaCidade(estado) {
        try {
            let response = await fetch(`/api/cidades/${estado}`);
            let cidades = await response.json();
            let options = cidades
                .map(
                    (cidade) =>
                        `<option value="${cidade.nome}">${cidade.nome}</option>`
                )
                .join("");
            $("#cidade").html(options);
        } catch (error) {
            console.error("Erro ao buscar cidades:", error);
        }
    }

    async function montaUF() {
        try {
            let response = await fetch("/api/estados");
            let estados = await response.json();
            estados.sort((a, b) => a.nome.localeCompare(b.nome));

            let options =
                `<option value=''>Escolha o Estado...</option>` +
                estados
                    .map(
                        (estado) =>
                            `<option value="${estado.sigla}">${estado.nome}</option>`
                    )
                    .join("");

            $("#estado").html(options);
            montaCidade($("#estado").val());

            $("#estado").change(function () {
                montaCidade($(this).val());
            });
        } catch (error) {
            console.error("Erro ao buscar estados:", error);
        }
    }

    async function montaPais() {
        try {
            let response = await fetch("/api/paises");
            let paises = await response.json();
            let options = paises
                .map(
                    (pais) =>
                        `<option value="${pais.Sigla}" ${
                            pais.Pais === "Brasil" ? "selected" : ""
                        }>${pais.Pais}</option>`
                )
                .join("");

            $("#pais").html(options);
            montaUF();

            $("#pais").change(function () {
                if ($("#pais").val() === "BR") {
                    $("#estado").remove();
                    $("#cidade").remove();
                    $("#campo_estado").append(
                        '<select id="estado" name="estado" class="form-control claim-required ipt-estado"><option value="" >Escolha o Estado...</option></select>'
                    );
                    $("#campo_cidade").append(
                        '<select id="cidade" name="cidade" class="form-control claim-required ipt-cidade" ><option value="" >Escolha a Cidade...</option></select>'
                    );
                    montaUF();
                } else {
                    $("#estado").remove();
                    $("#cidade").remove();
                    $("#campo_estado").append(
                        '<input type="text" name="estado" id="estado" class="form-control claim-required ipt-estado">'
                    );
                    $("#campo_cidade").append(
                        '<input type="text" name="cidade" id="cidade" class="form-control claim-required ipt-cidade">'
                    );
                }
            });
        } catch (error) {
            console.error("Erro ao buscar países:", error);
        }
    }

    montaPais();
    $("#assunto").trigger("change");
}
